import React from 'react';
import { Link, TooltipDefinition } from 'carbon-components-react';

type Props = {
  handleOnClick: Function;
};

const ConnectWithSocials: React.FC<Props> = () => {
  const iconNameLinkedIn = 'brand-social-logo-linkedin-32';
  const iconNameInstagram = 'brand-social-logo-insta-32';
  const iconNameFacebook = 'brand-social-logo-facebook-32';
  const iconNameYoutube = 'brand-social-logo-youtube-32';

  return (
    <React.Fragment>
      <div className="tile--clickable connectWithSocialsTile">
        <div className="tile--clickable-logo">
          <div className="social-media-wrapper">
            <TooltipDefinition
              tooltipText={'BYDA on LinkedIn'}
              direction={'bottom'}
              className="description"
            >
              <Link
                href="https://www.linkedin.com/company/before-you-dig-australia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`../social-media/${iconNameLinkedIn}.png`}
                  className="dbyd-certification-logo"
                  alt="BYDA on LinkedIn"
                />
              </Link>
            </TooltipDefinition>
            <TooltipDefinition
              tooltipText={'BYDA on Instagram'}
              direction={'bottom'}
              className="description"
            >
              <Link
                href="https://www.instagram.com/beforeyoudigaustralia/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`../social-media/${iconNameInstagram}.png`}
                  className="dbyd-certification-logo"
                  alt="BYDA on Instagram"
                />
              </Link>
            </TooltipDefinition>
            <TooltipDefinition
              tooltipText={'BYDA on Facebook'}
              direction={'bottom'}
              className="description"
            >
              <Link
                href="https://www.facebook.com/BYDAustralia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`../social-media/${iconNameFacebook}.png`}
                  className="dbyd-certification-logo"
                  alt="BYDA on Facebook"
                />
              </Link>
            </TooltipDefinition>
            <TooltipDefinition
              tooltipText={'BYDA on Youtube'}
              direction={'bottom'}
              className="description"
            >
              <Link
                href="https://www.youtube.com/channel/UCWW_UtL4TTNC2btrGiNXOGQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={`../social-media/${iconNameYoutube}.png`}
                  className="dbyd-certification-logo"
                  alt="BYDA on Youtube"
                />
              </Link>
            </TooltipDefinition>
          </div>
          <div className="tileHeader">
            <span>Connect with BYDA on socials</span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ConnectWithSocials;
